import { useTheme } from '@/shared/theme/ThemeContext'
import { HeaderIconButton } from '@/shared/ui/HeaderIconButton'
import styles from './ThemeToggle.module.css'

// The sun shows in light mode, the moon in dark.
const IconSun = () => (
  <svg viewBox='0 0 18 18' fill='currentColor' aria-hidden='true'>
    <path d='M9.75 18H8.25V15H9.75V18Z' />
    <path d='M5.2876 13.7729L3.1665 15.8943L2.10571 14.8337L4.22705 12.7124L5.2876 13.7729Z' />
    <path d='M15.8943 14.8335L14.8335 15.8943L12.7124 13.7729L13.7729 12.7124L15.8943 14.8335Z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9 4.5C11.4853 4.5 13.5 6.51472 13.5 9C13.5 11.4853 11.4853 13.5 9 13.5C6.51472 13.5 4.5 11.4853 4.5 9C4.5 6.51472 6.51472 4.5 9 4.5ZM9 6C7.34315 6 6 7.34315 6 9C6 10.6569 7.34315 12 9 12C10.6569 12 12 10.6569 12 9C12 7.34315 10.6569 6 9 6Z'
    />
    <path d='M3 9.75H0V8.25H3V9.75Z' />
    <path d='M18 9.75H15V8.25H18V9.75Z' />
    <path d='M5.2876 4.22681L4.22705 5.2876L2.10571 3.16626L3.16626 2.10571L5.2876 4.22681Z' />
    <path d='M15.8943 3.16626L13.7729 5.2876L12.7124 4.22705L14.8337 2.10571L15.8943 3.16626Z' />
    <path d='M9.75 3H8.25V0H9.75V3Z' />
  </svg>
)

// Drawn on a 24px grid, so it's shown at 20px to match the sun's weight.
const IconMoon = () => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    aria-hidden='true'
    className={styles.moon}
  >
    <path
      d='M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 1020.354 15.354Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinejoin='round'
    />
  </svg>
)

export const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme()
  const isDark = theme === 'dark'

  return (
    <HeaderIconButton
      icon={isDark ? <IconMoon /> : <IconSun />}
      aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      onClick={toggleTheme}
    />
  )
}
